import { render, staticRenderFns } from "./Traslados.vue?vue&type=template&id=5e2d738a"
import script from "./Traslados.vue?vue&type=script&lang=js"
export * from "./Traslados.vue?vue&type=script&lang=js"
import style0 from "./Traslados.vue?vue&type=style&index=0&id=5e2d738a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports